import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { ShippingVendorForm, ShippingVendorFormType } from './ShippingVendorForm'
import { getShippingVendorById, updateShippingVendor } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useParams } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Shipping Vendors',
    path: '/system/shipping-vendors'
  },
  {
    label: 'Edit',
    isCurrentPage: true
  }
]

export const EditShippingVendor = () => {
  const { vendorId } = useParams()
  const { createToast } = useAppContext()
  const [vendor, setVendor] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const row = await getShippingVendorById(vendorId)
        setVendor(row)
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [])

  const handleEdit = async (form) => {
    setIsSubmitting(true)

    try {
      const row = await updateShippingVendor(vendorId, {
        name: form.name,
        contact: form.contact,
        email: form.email,
        phone: form.phone,
        address: form.address,
        city: form.city,
        state: form.state,
        zip: form.zip,
        serviceRadiusMiles: form.serviceRadiusMiles
      })
      if (row) {
        setVendor(row)
        createToast('success', 'Shipping vendor updated.')
      } else {
        createToast('error', 'Failed to update.')
      }
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Edit Shipping Vendor</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <ShippingVendorForm
              type={ShippingVendorFormType.Edit}
              onSubmit={handleEdit}
              isSubmitting={isSubmitting}
              initialForm={vendor}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
